<template>
  <div class="app-main-inner app-main-page">
    <div
      v-show="showMainList"
      v-loading.fullscreen.lock="fullscreenLoading"
      class="app-main-inner app-main-page-tab"
      type="primary"
      element-loading-text=""
      element-loading-spinner="none"
      element-loading-background="rgba(170,170,170,0)"
    >
      <div class="app-main-inner-row">
        <search-item
          config-module="100"
          :reset="true"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        />
      </div>
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          style="width: 100%;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          v-show="filter.total>0"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="toQuery"
        />
      </div>
    </div>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
export default {
  name: 'Inventory',
  components: { searchItem },
  data() {
    return {
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      showBusinessCommission: false,
      fullscreenLoading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '包装号',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '包装类型',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '包装数(预/实)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '订单号',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: 'SKU编码',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: 'SKU数量',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '总件数',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '长(预/实)(cm)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '宽(预/实)(cm)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '高(预/实)(cm)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '单件体积(预/实)(m³)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '单件毛重(预/实)(KG)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '总体积(预/实)(m³)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '总毛重(预/实)',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '生产商',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '预计货好时间',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '实际进仓时间',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '实际出仓时间',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '来源',
          field: 'projectNo',
          width: 150
        },
        {
          headerName: '注意事项',
          field: 'projectNo',
          width: 150
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail && !this.showBusinessCommission
    }
  },
  beforeMount() {
    // this.fetchInventoryRequirement()
  },
  methods: {
    fetchInventoryRequirement() {
      this.fullscreenLoading = true
      /* findByProjectNo(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total);
          this.rowData = res.data.list;
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        }); */
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.projectNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      // findByProjectNo(this.filter).then((res) => this.handleQueryData(res));
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading = false
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      // advancedQuery(this.filterJson).then((res) => this.handleQueryData(res));
    }
  }
}
</script>
